import React, { useState } from "react";
import "./styles/MerchantScreen.css";
import "./styles/MerchantProfileScreen.css";
import SideBar from "../../Common/SideBar";
import { useDispatch, useSelector } from "react-redux";
import {
  collapseSidebar,
  expandSidebar,
} from "../../../store/reducers/sidebarSlice";
import {
  accountType,
  convertTimestampToDate,
  convertToFirestoreTimestamp,
  firestoreCollections,
  merchAccountStatus,
} from "../../../utils";
import {
  errorToast,
  infoToast,
  successToast,
} from "../../../services/toastService";
import { sendNotification } from "../../../services/firebaseService";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import {
  useFetchMerchantActivityByIdQuery,
  useFetchMerchantByIdQuery,
  useUpdateMerchantByIdMutation,
} from "../../../services/baseQuery";
import { OvalLoader } from "../../Common/Loaders";
import ProfileActivityLog from "./SubComponents/ProfileActivityLog";

export default function MerchantProfileScreen() {
  let navigate = useNavigate();
  const { merchantId } = useParams();
  const {
    data: merchantData,
    isLoading,
    isError,
    error,
  } = useFetchMerchantByIdQuery({ merchantId });
  const {
    isLoading: merchActivityLoading,
    isError: isFetchMerchActivityError,
    data: merchActivityData,
    error: fetchMerchActivityError,
  } = useFetchMerchantActivityByIdQuery({ merchantId: merchantId });

  const sidebar = useSelector(state => state.sidebar);
  const [blockMerchantBox, setBlockMerchantBox] = useState(false);
  const [blockTypePermanent, setBlockTypePermanent] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [updatedMerchData, setUpdatedMerchData] = useState({});
  const [updateMerchant] = useUpdateMerchantByIdMutation();
  const [updateMerchLoading, setUpdateMerchLoading] = useState(false);
  const [permBlockLoading, setPermBlockLoading] = useState(false);
  const [tempBlockLoading, setTempBlockLoading] = useState(false);
  const [blockReasonText, setBlockReasonText] = useState("");
  const [tempBlockDays, setTempBlockDays] = useState(0);
  const [merchUnblockLoading, setMerchUnblockLoading] = useState(false);

  // console.log(merchantData, "<<< merch data");

  const handleMerchBlock = async (type, data) => {
    if (!blockReasonText) infoToast("Please add reason for blocking.");
    else if ((type = "TEMPBLOCK" && tempBlockDays < 1))
      infoToast("Please mention no. of days for temporary block.");
    else {
      try {
        if (type == "TEMPBLOCK") setTempBlockLoading(true);
        else setPermBlockLoading(true);

        await updateMerchant({ merchantId, updatedMerchData: data });
        successToast("Merchant blocked successfully.");
      } catch (error) {
        errorToast("Error updating merchant.");
      } finally {
        if (type == "TEMPBLOCK") setTempBlockLoading(false);
        else setPermBlockLoading(false);
        setBlockMerchantBox(false);
      }
    }
  };

  const handleMerchUnblock = async () => {
    try {
      setMerchUnblockLoading(true);

      await updateMerchant({
        merchantId,
        updatedMerchData: {
          accountStatus: { type: merchAccountStatus.ACTIVE },
        },
      });
      successToast("Merchant unblocked successfully.");
    } catch (error) {
      errorToast("Error updating merchant.");
    } finally {
      setMerchUnblockLoading(false);
    }
  };

  const handleMerchantUpdate = async () => {
    try {
      setUpdateMerchLoading(true);
      await updateMerchant({ merchantId, updatedMerchData });
      successToast("Merchant updated successfully.");
      setEditMode(false);
    } catch (error) {
      errorToast("Error updating merchant.");
    } finally {
      setUpdateMerchLoading(false);
    }
  };

  const editMerchInputBox = (title, key) => {
    return (
      <div className="merchantInfoInnerContainer">
        <div className="merchantInfoHeader">{title} :</div>
        {editMode ? (
          <input
            className="merchantInfoEdit"
            placeholder={title}
            defaultValue={updatedMerchData[key]}
            onChange={e =>
              setUpdatedMerchData({
                ...updatedMerchData,
                [key]: e.target.value,
              })
            }
          />
        ) : (
          <div className="merchantInfo">{merchantData[key] || "-"}</div>
        )}
      </div>
    );
  };

  return (
    <div className="MainContainer">
      <SideBar />
      <div
        style={{ width: sidebar.expand ? "84vw" : "95vw" }}
        className="ScreenContainer merchantProfileScreenContainr"
      >
        {/* upper search bar start */}

        <div className="upperSearchBarContainer">
          <div className="upperBarSearchBar">
            <div className="pageHeadingInnerContainer">
              <img
                onClick={() => navigate(-1)}
                src={require("../../../assets/back_bold.png")}
                alt="back"
                className="merchantProfileBack"
              />
              {/* <img
                // src={require("../../../assets/addProfileColoured.png")}
                src={
                  activeMerchantData?.displayImage
                    ? `${activeMerchantData?.displayImage}`
                    : require("../../../assets/addProfileColoured.png")
                }
                alt="profile"
                className="merchantProfilePic"
              />
              <div className="pageHeading" style={{ marginLeft: "0.8vw" }}>
                Temp Company
              </div> */}
            </div>
          </div>

          {/* <div
            className="upperBarSearchBox upperBarSearchBoxProfile"
            style={{ border: "none" }}
          >
            <img
              src={require("../../../assets/profile.png")}
              alt="profile-pic"
            />
          </div> */}
          {/* <div className="upperBarSearchBox upperBarSearchBoxNotification">
            <img
              src={require("../../../assets/exit.png")}
              alt="notification-bell"
            />
          </div> */}
        </div>
        {isLoading || merchActivityLoading ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "14vh",
            }}
          >
            <div style={{ width: "20vw" }}>
              <OvalLoader visible={true} color="#3366CC" />
            </div>
          </div>
        ) : (
          <div className="merchantProfileInnerContainer">
            <div className="merchantInfoOuterContainer merchantProfileInnerHeader">
              <img
                // src={require("../../../assets/addProfileColoured.png")}
                src={
                  merchantData?.displayImage
                    ? `${merchantData?.displayImage}`
                    : require("../../../assets/profile.jpg")
                }
                alt="profile picture"
                className="merchantProfilePic"
              />
              <div className="merchantProfileHeader">
                <div className="merchantProfileName">
                  {merchantData.displayName}
                </div>
                {merchantData?.category && merchantData.category.length > 0 && (
                  <div className="merchant-categories profile-categories">
                    {merchantData.category.map((category, index) => (
                      <span key={index} className="merchant-category-badge">
                        {category.name}
                      </span>
                    ))}
                  </div>
                )}
              </div>
              {!editMode && (
                <div
                  className="merchantEditProfile"
                  onClick={() => {
                    setUpdatedMerchData({
                      displayName: merchantData.displayName,
                      representativeName: merchantData.representativeName,
                      compRegistrationNo: merchantData.compRegistrationNo,
                      vatNo: merchantData.vatNo,
                      phoneNumber: merchantData.phoneNumber,
                      email: merchantData.email,
                      bankName: merchantData.bankName,
                      IBAN: merchantData.IBAN,
                      address: merchantData.address,
                      description: merchantData.description,
                      projectFeesToAdmin: merchantData.projectFeesToAdmin,
                    });
                    setEditMode(true);
                  }}
                >
                  Edit Profile
                </div>
              )}
            </div>
            <div className="merchantInfoOuterContainer">
              {/* <div className="merchantInfoInnerContainer">
                <div className="merchantInfoHeader">
                  Representative's Name :
                </div>
                {editMode ? (
                  <input
                    className="merchantInfoEdit"
                    placeholder="Representative Name"
                    defaultValue={updatedMerchData.representativeName}
                    onChange={e =>
                      setUpdatedMerchData({
                        ...updatedMerchData,
                        representativeName: e.target.value,
                      })
                    }
                  />
                ) : (
                  <div className="merchantInfo">
                    {merchantData.representativeName}
                  </div>
                )}
              </div> */}
              {editMerchInputBox("Representative's Name", "representativeName")}
              {/* <div className="merchantInfoInnerContainer">
                <div className="merchantInfoHeader">
                  Company Registration no. :
                </div>
                {editMode ? (
                  <input
                    className="merchantInfoEdit"
                    placeholder="Company Registration no."
                    defaultValue={updatedMerchData.compRegistrationNo}
                  />
                ) : (
                  <div className="merchantInfo">
                    {merchantData.compRegistrationNo}
                  </div>
                )}
              </div> */}
              {editMerchInputBox(
                "Company Registration no.",
                "compRegistrationNo"
              )}
            </div>
            <div className="merchantInfoOuterContainer">
              {/* <div className="merchantInfoInnerContainer">
                <div className="merchantInfoHeader">Vat no. :</div>
                {editMode ? (
                  <input
                    className="merchantInfoEdit"
                    placeholder="Vat no."
                    defaultValue={updatedMerchData.vatNo}
                    onChange={e =>
                      setUpdatedMerchData({
                        ...updatedMerchData,
                        vatNo: e.target.value,
                      })
                    }
                  />
                ) : (
                  <div className="merchantInfo">
                    {merchantData.vatNo || "-"}
                  </div>
                )}
              </div> */}
              {editMerchInputBox("Vat no.", "vatNo")}
              {/* <div className="merchantInfoInnerContainer">
                <div className="merchantInfoHeader">
                  Project Fees To Admin :
                </div>
                {editMode ? (
                  <input
                    className="merchantInfoEdit"
                    placeholder="Project Fees To Admin"
                    defaultValue={updatedMerchData.projectFeesToAdmin}
                  />
                ) : (
                  <div className="merchantInfo">
                    {merchantData.projectFeesToAdmin}%
                  </div>
                )}
              </div> */}
              {editMerchInputBox(
                "Project Fees To Admin (%)",
                "projectFeesToAdmin"
              )}
            </div>
            <div className="merchantInfoOuterContainer">
              {/* <div className="merchantInfoInnerContainer">
                <div className="merchantInfoHeader">Phone Number :</div>
                {editMode ? (
                  <input
                    className="merchantInfoEdit"
                    placeholder="Phone Number"
                    defaultValue={updatedMerchData.phoneNumber}
                  />
                ) : (
                  <div className="merchantInfo">{merchantData.phoneNumber}</div>
                )}
              </div> */}
              {/* {editMerchInputBox("Phone Number", "phoneNumber")} */}
              <div className="merchantInfoInnerContainer">
                <div className="merchantInfoHeader">Phone Number :</div>
                <div className="merchantInfo">{merchantData.phoneNumber}</div>
              </div>
              {/* <div className="merchantInfoInnerContainer">
                <div className="merchantInfoHeader">Email :</div>
                {editMode ? (
                  <input
                    className="merchantInfoEdit"
                    placeholder="Email"
                    defaultValue={updatedMerchData.email}
                  />
                ) : (
                  <div className="merchantInfo">{merchantData.email}</div>
                )}
                </div> */}
              {editMerchInputBox("Email", "email")}
            </div>
            <div className="merchantInfoOuterContainer">
              {/* <div className="merchantInfoInnerContainer">
                <div className="merchantInfoHeader">Bank name :</div>
                {editMode ? (
                  <input
                    className="merchantInfoEdit"
                    placeholder="Bank Name"
                    defaultValue={updatedMerchData.bankName}
                  />
                ) : (
                  <div className="merchantInfo">{merchantData.bankName}</div>
                  )}
              </div> */}
              {editMerchInputBox("Bank name", "bankName")}
              {/* <div className="merchantInfoInnerContainer">
                <div className="merchantInfoHeader">IBAN :</div>
                {editMode ? (
                  <input
                    className="merchantInfoEdit"
                    placeholder="IBAN"
                    defaultValue={updatedMerchData.IBAN}
                  />
                ) : (
                  <div className="merchantInfo">{merchantData.IBAN}</div>
                  )}
                  </div> */}
              {editMerchInputBox("IBAN", "IBAN")}
            </div>
            <div className="merchantInfoOuterContainer">
              <div className="merchantInfoInnerContainerBig">
                <div className="merchantInfoHeader">Wallet Balance :</div>
                <div className="merchantInfo">
                  {merchantData.walletBalance} SAR
                </div>
              </div>
            </div>
            <div className="merchantInfoOuterContainer">
              <div className="merchantInfoInnerContainerBig">
                <div className="merchantInfoHeader">Categories :</div>
                <div className="merchantInfo categories-section">
                  {merchantData?.category &&
                  merchantData.category.length > 0 ? (
                    <div className="merchant-categories">
                      {merchantData.category.map((category, index) => (
                        <span
                          key={index}
                          className="merchant-category-badge profile-section-badge"
                        >
                          {category.name}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <span>No categories assigned</span>
                  )}
                </div>
              </div>
            </div>
            <div className="merchantInfoOuterContainer">
              <div className="merchantInfoInnerContainerBig">
                <div className="merchantInfoHeader">Company Address :</div>
                {editMode ? (
                  <textarea
                    className="merchantInfoEdit"
                    placeholder="Company Address"
                    defaultValue={updatedMerchData.address}
                  />
                ) : (
                  <div className="merchantInfo">{merchantData.address}</div>
                )}
              </div>
            </div>
            <div className="merchantInfoOuterContainer">
              <div className="merchantInfoInnerContainerBig">
                <div className="merchantInfoHeader">Description :</div>
                {editMode ? (
                  <textarea
                    className="merchantInfoEdit"
                    placeholder="Description"
                    defaultValue={updatedMerchData.description}
                  />
                ) : (
                  <div className="merchantInfo">{merchantData.description}</div>
                )}
              </div>
            </div>
            {editMode && (
              <div
                className="blockButtonContainer"
                style={{ marginBottom: "-2vh" }}
              >
                <div
                  className="blockButton updateFont"
                  style={{ fontWeight: 600 }}
                  onClick={updateMerchLoading ? null : handleMerchantUpdate}
                >
                  {updateMerchLoading ? (
                    <OvalLoader visible={true} color="#3366CC" />
                  ) : (
                    "Update Profile"
                  )}
                </div>
                <div
                  className="blockButtonSecondary updateFont"
                  style={{ fontWeight: 600 }}
                  onClick={
                    updateMerchLoading
                      ? null
                      : () => {
                          setEditMode(false);
                        }
                  }
                >
                  Cancel
                </div>
              </div>
            )}

            {/* merchant blocking UI starts */}
            {!editMode && (
              <>
                {merchantData.accountStatus.type ==
                  merchAccountStatus.UNVERIFIED && (
                  <div className="unblockContainer">
                    <div className="blockedText">
                      Merchant profile verification pending.
                    </div>
                  </div>
                )}

                {merchantData.accountStatus.type ==
                  merchAccountStatus.ACTIVE && (
                  <div
                    className="blockMerchant"
                    onClick={() => setBlockMerchantBox(true)}
                  >
                    Block Merchant
                  </div>
                )}
              </>
            )}

            {blockMerchantBox && (
              <div className="blockBox">
                <div className="radioButtonContainer">
                  <div className="radioButton">
                    <div
                      className="customRadioButtonContainer"
                      onClick={
                        permBlockLoading || tempBlockLoading
                          ? null
                          : () => setBlockTypePermanent(false)
                      }
                    >
                      {!blockTypePermanent && (
                        <div className="customRadioButton"></div>
                      )}
                    </div>
                    Temporary Block
                  </div>
                  <div className="radioButton">
                    <div
                      className="customRadioButtonContainer"
                      onClick={
                        permBlockLoading || tempBlockLoading
                          ? null
                          : () => setBlockTypePermanent(true)
                      }
                    >
                      {blockTypePermanent && (
                        <div className="customRadioButton"></div>
                      )}
                    </div>
                    Permanent Block
                  </div>
                </div>
                {blockTypePermanent ? (
                  <div className="confirmBlock">
                    <div>Reason (max. 200 characters) :</div>
                    <textarea
                      maxlength="200"
                      placeholder="Reason for blocking.."
                      className="tempBlockDaysInput"
                      onChange={e => {
                        if (e.target.value.length < 200)
                          setBlockReasonText(e.target.value);
                      }}
                    />
                    <div style={{ marginTop: "1vh" }}>
                      Are you sure you want to block this merchant permanently?
                    </div>
                    <div className="blockButtonContainer">
                      <div
                        className="blockButton"
                        onClick={
                          permBlockLoading
                            ? null
                            : () =>
                                handleMerchBlock("PERMBLOCK", {
                                  accountStatus: {
                                    type: merchAccountStatus.PERMANENT_BLOCK,
                                    reason: blockReasonText,
                                    blockedOn: convertToFirestoreTimestamp(
                                      new Date()
                                    ),
                                  },
                                })
                        }
                      >
                        {permBlockLoading ? (
                          <OvalLoader visible={true} color="#3366CC" />
                        ) : (
                          "Block Permanently"
                        )}
                      </div>
                      <div
                        className="blockButtonSecondary"
                        onClick={
                          permBlockLoading
                            ? null
                            : () => setBlockMerchantBox(false)
                        }
                      >
                        Cancel
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="confirmBlock">
                    <div>Reason (max. 200 characters) :</div>
                    <textarea
                      maxlength="200"
                      placeholder="Reason for blocking.."
                      className="tempBlockDaysInput"
                      onChange={e => {
                        if (e.target.value.length < 200)
                          setBlockReasonText(e.target.value);
                      }}
                    />
                    <div style={{ marginTop: "1vh" }}>Duration :</div>
                    <input
                      placeholder="Time in days.."
                      className="tempBlockDaysInput"
                      type="number"
                      onChange={e => setTempBlockDays(e.target.value)}
                    />
                    <div className="blockButtonContainer">
                      <div
                        className="blockButton"
                        onClick={
                          tempBlockLoading
                            ? null
                            : () =>
                                handleMerchBlock("TEMPBLOCK", {
                                  accountStatus: {
                                    type: merchAccountStatus.TEMP_BLOCK,
                                    reason: blockReasonText,
                                    daysBlocked: tempBlockDays,
                                    blockedOn: convertToFirestoreTimestamp(
                                      new Date()
                                    ),
                                  },
                                })
                        }
                      >
                        {tempBlockLoading ? (
                          <OvalLoader visible={true} color="#3366CC" />
                        ) : (
                          "Block Temporarily"
                        )}
                      </div>
                      <div
                        className="blockButtonSecondary"
                        onClick={
                          tempBlockLoading
                            ? null
                            : () => setBlockMerchantBox(false)
                        }
                      >
                        Cancel
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* merchant blocking UI ends */}

            {/* merchant unblocking Ui starts */}
            {(merchantData.accountStatus.type ==
              merchAccountStatus.PERMANENT_BLOCK ||
              merchantData.accountStatus.type ==
                merchAccountStatus.TEMP_BLOCK) && (
              <div className="unblockContainer">
                <div className="blockedText">
                  {merchantData.accountStatus.type ==
                  merchAccountStatus.PERMANENT_BLOCK
                    ? "Merchant is blocked permanently."
                    : `This merchant was temporarily blocked on ${convertTimestampToDate(
                        merchantData.accountStatus.blockedOn
                      )} for ${merchantData.accountStatus.daysBlocked} days.`}
                </div>
                <div className="blockedText">
                  Reason: {merchantData.accountStatus.reason}
                </div>
                {merchUnblockLoading ? (
                  <div className="unblockMerchant">
                    <OvalLoader visible={true} color="#ffffff" />
                  </div>
                ) : (
                  <div className="unblockMerchant" onClick={handleMerchUnblock}>
                    Unblock Merchant
                  </div>
                )}
              </div>
            )}
            {/* merchant unblocking UI ends */}
            <div className="activityLogContainerProfileScreen">
              <div className="modalFeildContainer">
                <div
                  style={{
                    fontSize: "1.8vh",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                  }}
                >
                  Activity Log
                </div>
              </div>
              <ProfileActivityLog
                activityData={merchActivityData}
                isLoading={merchActivityLoading}
                isError={isFetchMerchActivityError}
                error={fetchMerchActivityError}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
